import { render, staticRenderFns } from "./RankingHome.vue?vue&type=template&id=93f8dc0c"
import script from "./RankingHome.vue?vue&type=script&lang=js"
export * from "./RankingHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports